const STORAGE_KEY = "divyayoga_music_paused";

const BASE_URL = `${process.env.REACT_APP_API_URL || "http://localhost:5154"}/api`;

const getInitialAudioSrc = () => {
  try {
    const saved = localStorage.getItem("divyayoga_appearance");
    const parsed = saved ? JSON.parse(saved) : null;
    return parsed?.bgMusicUrl || parsed?.BgMusicUrl || "/assets/divyyog_music.mp3";
  } catch {
    return "/assets/divyyog_music.mp3";
  }
};

const globalAudio = new Audio(getInitialAudioSrc());
globalAudio.loop   = true;
globalAudio.volume = 0.18;

// Fetch real R2 background music setting from backend API on init
if (typeof window !== "undefined") {
  fetch(`${BASE_URL}/admin/settings/appearance`)
    .then(res => res.json())
    .then(raw => {
      const data = raw?.data || raw?.Data;
      const remoteSrc = data?.bgMusicUrl || data?.BgMusicUrl;
      if (remoteSrc && globalAudio.src !== remoteSrc) {
        const wasPlaying = !globalAudio.paused;
        globalAudio.pause();
        globalAudio.src = remoteSrc;
        if (wasPlaying) {
          globalAudio.play().catch(() => {});
        }
      }
    })
    .catch(() => {});

  // Live listener when Super Admin uploads new background music in Settings
  const handleAudioUpdate = (e) => {
    let data = e?.detail;
    if (!data) {
      try { data = JSON.parse(localStorage.getItem("divyayoga_appearance") || "{}"); } catch { data = {}; }
    }
    const newSrc = data?.bgMusicUrl || data?.BgMusicUrl || "/assets/divyyog_music.mp3";
    if (newSrc && globalAudio.src !== newSrc) {
      const wasPlaying = !globalAudio.paused;
      globalAudio.pause();
      globalAudio.src = newSrc;
      if (wasPlaying) {
        globalAudio.play().catch(() => {});
      }
    }
  };

  window.addEventListener("divyayoga-appearance-updated", handleAudioUpdate);
  window.addEventListener("storage", handleAudioUpdate);
}

// Restore the user's pause choice so it survives page reloads / refreshes.
let userPaused = false;
try {
  userPaused = sessionStorage.getItem(STORAGE_KEY) === "true";
} catch {}

export const setUserPaused = (val) => {
  userPaused = val;
  try {
    sessionStorage.setItem(STORAGE_KEY, val ? "true" : "false");
  } catch {}
};
export const getUserPaused = () => userPaused;

export const stopGlobalAudio = () => {
  globalAudio.pause();
  globalAudio.currentTime = 0;
};

export { globalAudio };
